import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { DOCUMENT, ErrorHandler, inject, NgModule, provideAppInitializer, REQUEST } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { BaseModule } from '@modules/base/base.module';
import { AuthGuard } from '@modules/content-api/guard/auth.guard';
import { PreMediaGuard } from '@modules/content-api/guard/pre-media.guard';
import { RedirectGuard } from '@modules/content-api/guard/redirect.guard';
import { NoTranslationInterceptor } from '@modules/content-api/interceptor/no-translation.interceptor';
import { FavoritesModule } from '@modules/favorites/favorites.module';
import { ScrollSpyModule } from '@modules/shared/scroll-spy/scroll-spy.module';
import { SharedModule } from '@modules/shared/shared.module';
import { environment } from 'src/environments/environment';
import { Locale } from 'src/environments/language.config';

import { AppErrorHandler } from './app-error-handler';
import { AppRoutingModule } from './app-routing.module';
import { AppService } from './app.service';

registerLocaleData(localeDe);

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BaseModule,
    SharedModule.forRoot(),
    ScrollSpyModule.forRoot(),
    FavoritesModule,
  ],
  providers: [
    AppService,
    PreMediaGuard,
    AuthGuard,
    RedirectGuard,
    ApplicationinsightsAngularpluginErrorService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoTranslationInterceptor,
      multi: true,
    },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideTranslateService({
      fallbackLang: Locale.DE,
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: `.json?v=${environment.i18nVersion}`,
      }),
    }),
    provideAppInitializer(() => {
      const request = inject(REQUEST, { optional: true });
      const document = inject(DOCUMENT);
      const translateService = inject(TranslateService);
      const pathname = request ? new URL(request.url).pathname : document?.location?.pathname || '';
      const lang = /^\/en(?:\/|$)/.test(pathname) ? Locale.EN : Locale.DE;
      translateService.use(lang);
    }),
  ],
})
export class AppModule {}
